import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const GRADE_LEVEL = 'grade_level'
const SUBJECT = 'subject'
const SEARCH = 'search'

/**
 * Form model
 */
const formModel = () => {
  return {
    [GRADE_LEVEL]: {
      label: `${t('common.grade-level')}`,
      name: GRADE_LEVEL,
    },
    [SUBJECT]: {
      label: `${t('common.subject')}`,
      name: SUBJECT,
      required: true,
    },
    [SEARCH]: {
      label: `${t('dashboard.search-worksheets')}`,
      name: SEARCH,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [GRADE_LEVEL]: null,
  [SUBJECT]: null,
  [SEARCH]: '',
}

export default formModel
